<template>
  <RouterLink :to="to" :exact="exact">
    {{ this.toLang.toUpperCase() }}
  </RouterLink>
</template>

<script>
export default {
  name: 'LangSwitchLink',
  props: {
    exact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    to() {
      const routeName = this.$route.name ?? 'home'
      return {
        ...this.$route,
        name:
          this.toLang !== this.$i18n.fallbackLocale
            ? `${routeName}:${this.toLang}`
            : routeName.substring(0, routeName.indexOf(':')),
      }
    },
    toLang() {
      return this.$i18n.availableLocales.find((lang) => lang !== this.$i18n.locale)
    },
  },
}
</script>
